import { hasValue } from './value';

export function parseToInt(val: string | null | undefined, def: number | undefined = 0) {
    if (!val) return def;
    const intValue = parseInt(val);
    return isNaN(intValue) ? def : intValue;
}

export function toInt(
    val: string | number | null | undefined,
    def: number | undefined = undefined
) {
    const value = hasValue(val, def);
    return value === undefined ? value : parseInt(value.toString());
}

export function toFloat(
    val: string | number | null | undefined,
    def: number | undefined = undefined
) {
    const value = hasValue(val, def);
    return value === undefined ? value : parseFloat(value.toString());
}
